import {UpdateTemplate, TemplateMode, TemplateStatus, TemplateDocumentType} from '@shipwell/template-builder-sdk';

export interface TemplateFormValues {
  description: string;
  status: TemplateStatus;
  document_type: TemplateDocumentType;
  allowed_modes: TemplateMode[];
}

export const generateTemplateInitialValues = (template: UpdateTemplate): TemplateFormValues => {
  return {
    description: template.description || '',
    status: template.status || 'ACTIVE',
    document_type: template.document_type || '',
    allowed_modes: template.allowed_modes || []
  };
};
